<template>
  <div id="app">
    <Header></Header>
    <Chat v-if="activeUser" :contactPerson="activeUser.spc"/>
    <Chat v-else/>
    <transition name="page" mode="out-in">
      <router-view class="main"/>
    </transition>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Chat from './components/Chat/Chat';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Chat,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      activeUser: 'auth/getUserSession',
    }),
  },  
  methods: {
    ...mapActions({
        refresh: 'auth/refresh',
      }),
  },
  created() {
    this.refresh();
  },
};
</script>

<style src="./assets/scss/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue